import { Box, styled } from '@mui/material';

export const ChipSpacer = styled(Box)`
  margin: 0 5px 5px 0;
  display: inline-block;
`;
